export default __webpack_public_path__ + "static/media/img-b-02-charging-bg.b0645ff2.png";